@if (!consent.hasResponded()) {
  <div class="consent-banner" role="dialog" aria-label="Cookie consent" aria-live="polite">
    <div class="consent-banner__inner">
      <div class="consent-banner__row">
        <div class="consent-banner__info-group">
          <svg class="consent-banner__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
          <p class="consent-banner__text">
            This site uses cookies. Visit our
            <a routerLink="/privacy-policy" class="consent-banner__link">cookies policy page</a>
            or click the link in any footer for more information and to
            <button class="consent-banner__manage" (click)="togglePreferences()">change your preferences</button>.
          </p>
        </div>

        <div class="consent-banner__actions">
          <button class="consent-banner__btn consent-banner__btn--outline" (click)="acceptAll()">
            Accept all cookies
          </button>
          <button class="consent-banner__btn consent-banner__btn--outline" (click)="rejectAll()">
            Essentials only
          </button>
        </div>
      </div>

      @if (showPreferences()) {
        <div class="consent-banner__preferences">
          <div class="consent-banner__pref-item">
            <div class="consent-banner__pref-info">
              <span class="consent-banner__pref-label">Essential cookies</span>
              <span class="consent-banner__pref-desc">Required for the site to function. Cannot be disabled.</span>
            </div>
            <span class="consent-banner__pref-badge">Always on</span>
          </div>

          <div class="consent-banner__pref-item">
            <div class="consent-banner__pref-info">
              <span class="consent-banner__pref-label">Analytics cookies</span>
              <span class="consent-banner__pref-desc">Help us understand how visitors interact with our site (Google Analytics, Microsoft Clarity).</span>
            </div>
            <label class="consent-banner__toggle">
              <input type="checkbox" [checked]="analyticsToggle()" (change)="analyticsToggle.set($any($event.target).checked)">
              <span class="consent-banner__toggle-slider"></span>
            </label>
          </div>

          <button class="consent-banner__btn consent-banner__btn--filled consent-banner__btn--save" (click)="savePreferences()">
            Save preferences
          </button>
        </div>
      }
    </div>
  </div>
}

@if (consent.showManagePanel() && consent.hasResponded()) {
  <div class="consent-banner consent-banner--manage" role="dialog" aria-label="Cookie preferences">
    <div class="consent-banner__inner">
      <div class="consent-banner__header">
        <span class="consent-banner__title">Cookie preferences</span>
        <button class="consent-banner__close" (click)="closeManage()" aria-label="Close">
          <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
            <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
          </svg>
        </button>
      </div>

      <div class="consent-banner__preferences consent-banner__preferences--no-border">
        <div class="consent-banner__pref-item">
          <div class="consent-banner__pref-info">
            <span class="consent-banner__pref-label">Essential cookies</span>
            <span class="consent-banner__pref-desc">Required for the site to function. Cannot be disabled.</span>
          </div>
          <span class="consent-banner__pref-badge">Always on</span>
        </div>

        <div class="consent-banner__pref-item">
          <div class="consent-banner__pref-info">
            <span class="consent-banner__pref-label">Analytics cookies</span>
            <span class="consent-banner__pref-desc">Help us understand how visitors interact with our site (Google Analytics, Microsoft Clarity).</span>
          </div>
          <label class="consent-banner__toggle">
            <input type="checkbox" [checked]="analyticsToggle()" (change)="analyticsToggle.set($any($event.target).checked)">
            <span class="consent-banner__toggle-slider"></span>
          </label>
        </div>

        <button class="consent-banner__btn consent-banner__btn--filled consent-banner__btn--save" (click)="saveAndClose()">
          Save preferences
        </button>
      </div>
    </div>
  </div>
}
